import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AbstractSecurityStorage } from 'angular-auth-oidc-client';

import { IdleTimeModule } from '@app/modules/ui-components/components/idle-time/idle-time.module';
import { NewTurnoverModalModule } from '@app/modules/ui-components/modals/new-turnover-modal/new-turnover-modal.module';
import { OidcStorageService } from '@app/services/oidc-storage.service';
import { NotificationsModule } from '@main-application/notifications/notifications.module';
import { PortfolioStoreModule } from '@portfolio/store/portfolio-store.module';
import { DirectivesModule } from '@shared/directives/directives.module';
import { PipesModule } from '@shared/pipes/pipes.module';
import { ValueIfNonZeroPipe } from '@shared/pipes/valueIfNonZero.pipe';
import { ValueIfPositivePipe } from '@shared/pipes/valueIfPositive.pipe';
import { YesEmptyPipe } from '@shared/pipes/yesEmpty.pipe';
import { AnimationModule } from '@ui-components/components/animation/animation.module';
import { AvatarModule } from '@ui-components/components/avatar/avatar.module';
import { IconComponent } from '@ui-components/components/icon/icon.component';
import { NotificationRingModule } from '@ui-components/components/notification-ring/notification-ring.module';
import { RadioButtonDropdownModule } from '@ui-components/components/radio-button-dropdown/radio-button-dropdown.module';
import { SearchInputModule } from '@ui-components/components/search-input/search-input.module';
import { ModalsModule } from '@ui-components/modals/modals.module';

import { ApplicationMenuComponent } from './application-menu.component';
import { ApplicationMenuRoutingModule } from './application-menu.routing.module';
import { BreadcrumbItemComponent } from './breadcrumb-item/breadcrumb-item.component';
import { PropertySelectorComponent } from './property-selector/property-selector.component';
import { SidePanelComponent } from './side-panel/side-panel.component';
import { SidePanelSectionComponent } from './side-panel-section/side-panel-section.component';
import { SidePanelSectionItemComponent } from './side-panel-section-item/side-panel-section-item.component';
import { TopPanelComponent } from './top-panel/top-panel.component';

@NgModule({
  declarations: [
    ApplicationMenuComponent,
    SidePanelComponent,
    SidePanelSectionComponent,
    SidePanelSectionItemComponent,
    TopPanelComponent,
    PropertySelectorComponent,
    BreadcrumbItemComponent,
  ],
  imports: [
    CommonModule,
    NotificationsModule,

    ModalsModule,
    FormsModule,
    ReactiveFormsModule,

    MatAutocompleteModule,
    MatBadgeModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatRadioModule,
    MatSelectModule,
    MatSidenavModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTabsModule,
    MatTableModule,
    MatToolbarModule,
    MatTooltipModule,
    MatChipsModule,
    MatProgressSpinnerModule,

    ApplicationMenuRoutingModule,
    PipesModule,
    IdleTimeModule,
    DirectivesModule,
    NewTurnoverModalModule,
    ModalsModule,
    PortfolioStoreModule,
    AnimationModule,
    IconComponent,
    AvatarModule, //ToDo: make it stand alone component & move out from master-module
    SearchInputModule, //ToDo: make it stand alone component & move out from master-module
    RadioButtonDropdownModule, //ToDo: (maybe?) make it stand alone component & move out from master-module
    NotificationRingModule, //ToDo: make it stand alone component & move out from master-module
  ],
  providers: [
    YesEmptyPipe,
    ValueIfPositivePipe,
    ValueIfNonZeroPipe,
    { provide: AbstractSecurityStorage, useClass: OidcStorageService },
  ],
})
export class ApplicationMenuModule {}
